import script from "./design-search-input.vue?vue&type=script&setup=true&lang=js"
export * from "./design-search-input.vue?vue&type=script&setup=true&lang=js"

import "./design-search-input.vue?vue&type=style&index=0&id=146f0a41&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/PRD_sharetreats_v1_hr_admin_dashboard_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-146f0a41"]])

export default __exports__